<template lang="html">
  <div class="ml-1 overlay_form">
    <h5>Shape overlay</h5>
    <OverlayCommonTimingOptions :overlay="overlay" />
    <b-row>
      <b-col sm="6">
        <ColorPicker
          :value="overlay.text_background_color_rgba"
          :active="overlay.text_background"
          label="Background color"
          :optional="false"
          @deactivated="
            value_changed(
              'text_background',
              false,
              'text_background_color_rgba',
              'white'
            )
          "
          @changed="
            v =>
              value_changed(
                'text_background_color_rgba',
                v,
                'text_background',
                true
              )
          "
        />
      </b-col>
    </b-row>

    <b-row v-if="overlay.text_background">
      <b-col>
        <ColorPicker
          :value="overlay.text_background_border_rgba"
          :active="overlay.text_background_border_em != 0"
          label="Border color"
          @deactivated="
            value_changed(
              'text_background_border_em',
              0,
              'text_background_border_rgba',
              '#333333FF'
            )
          "
          @changed="v => changeBorderColor(v)"
        />
        <div v-if="overlay.text_background_border_em != 0">
          <Slider
            :value="overlay.text_background_border_em"
            :min="0.1"
            :max="2"
            :interval="0.1"
            label="Border size"
            @changed="v => value_changed('text_background_border_em', v)"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import ColorPicker from "./ui/ColorPicker";
import isEqual from "lodash/isEqual";
import Slider from "./ui/Slider";
import OverlayCommonTimingOptions from "./OverlayCommonTimingOptions";
export default {
  name: "OverlayTextColor",
  components: {
    ColorPicker,
    Slider,
    OverlayCommonTimingOptions
  },
  props: {
    overlay: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      alignment_options: [
        { value: "left", icon: "align-left" },
        { value: "center", icon: "align-center" },
        { value: "right", icon: "align-right" }
      ],

      text_background_options: [
        { text: "Text Background", value: true },
        { text: "Hide Text Background", value: false }
      ],
      text_shadow_options: [
        { text: "None", value: 0 },
        { text: "Light", value: 15 },
        { text: "Default", value: 30 },
        { text: "Strong", value: 60 }
      ],
      vertical_alignment_options: [
        { value: "top", icon: "long-arrow-alt-up" },
        { text: "-", value: "middle" },
        { value: "bottom", icon: "long-arrow-alt-down" }
      ],
      font_options: this.$store.state.overlays.overlay_font_options
    };
  },
  computed: {},
  methods: {
    toggleBorder(value) {
      if (value) {
        this.value_changed("text_background_border_em", 0.3);
      } else {
        this.value_changed("text_background_border_em", 0);
      }
    },
    changeBorderColor(value) {
      if (this.overlay.text_background_border_em == 0) {
        this.value_changed(
          "text_background_border_rgba",
          value,
          "text_background_border_em",
          0.2
        );
      } else {
        this.value_changed("text_background_border_rgba", value);
      }
    },
    value_changed(
      property,
      new_value,
      additional_property,
      additional_new_value
    ) {
      console.log("value_changed", property, new_value);
      var overlayObject = cloneDeep(this.overlay);
      overlayObject[property] = new_value;
      if (additional_property) {
        overlayObject[additional_property] = additional_new_value;
      }
      var overlayUnchanged = isEqual(overlayObject, cloneDeep(this.overlay));
      if (!overlayUnchanged) {
        this.$store.dispatch("overlays/updateOverlay", overlayObject);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.z-higher-picker {
  position: relative;
  z-index: 2000;
}
</style>
